import request from '@/utils/request'

const dataObj = {
	version: '1.0',
	nonceStr: '1212fsadf',
	timestamp: '2020-4-21',
	signType: 'md5',
	content: { object: { merchantId: 1 } },
	sign: 'dafdsf'
}

// 获取大屏食堂权限配置
export function getDaPing (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ds/authority/canteen/getdscanteenauthority',
		method: 'post',
		data: obj
	})
}
// 新增大屏食堂权限配置
export function addDaPing (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ds/authority/canteen/savedscanteenauthority',
		method: 'post',
		data: obj
	})
}
// 修改大屏食堂权限配置
export function putDaPing (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ds/authority/canteen/updatedscanteenauthority',
		method: 'post',
		data: obj
	})
}
// 删除大屏食堂权限配置
export function delDaPing (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	console.log(obj, data, 'sss')
	return request({
		url: '/ds/authority/canteen/deleteCanteenAuthority',
		method: 'post',
		data: obj
	})
}

// 当天充值消费汇总查询图表
export function getTodayTradeChart (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/web/home/analysis/chart/charttradesum',
		method: 'post',
		data: obj
	})
}

// 一周订单汇总查询图表
export function getWeekOrdSumChart (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/web/home/analysis/chart/chartordsum',
		method: 'post',
		data: obj
	})
}

// 图表-当天各餐次订单汇总
export function getTodayOrdSumChart (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/web/home/analysis/chart/todayordsum',
		method: 'post',
		data: obj
	})
}
// 数据大屏-user
export function getTodayCaipin (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/datascreen/getdatascreen',
		method: 'post',
		data: obj,
		noLoading: true
	})
}
// 数据大屏-merchant
export function getMerchantsreen (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/datascreen/getdatascreen/merchant',
		method: 'post',
		data: obj,
		noLoading: true
	})
}
